import {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import useInput, {useInputWithMaxLength, useNumberWithMaxLength} from "../../hooks/useInput";
import CustomModal from "../CustomModal";
import Input from "../form/Input";
import {ProvinceSelector} from "./ProvinceSelector";
import {LocationSelector} from "./LocationSelector";
import {tryPostNewAddress} from "../../redux/slices/addressSlice";

export const AddressModal = ({showModal, setShowModal, customerId, isCampaign = false}) => {

  const [editPopup, setEditPopUp] = useState();

  const dispatch = useDispatch()

  const [province, setProvince] = useState()
  const [city, setCity] = useState()
  const [area, setArea] = useState()

  const label = 'Pharmacy Generated Address'
  const landmark = useInput("")
  const alternateNumber = useNumberWithMaxLength("", 10)
  const isDefault = useInput(false, true)

  const isDefaultAddress = useRef(false);

  useEffect(() => {
    reset();
  }, [editPopup])

  const isAllFieldValid = () => {
    return (province && city && area && label.trim() && landmark.value.trim() && (!alternateNumber.value.trim() || alternateNumber.value.trim().length > 9))
  }

  const isNotAvailableForCampaign = isCampaign && (!province?.campaign_location || !city?.campaign_location || !area?.campaign_location);

  const reset = () => {
    setProvince(null)
    setCity(null)
    setArea(null)
    // label.setValue("")
    landmark.setValue("")
    alternateNumber.setValue("")
    isDefault.setValue(false)
    isDefaultAddress.current = false
  }

  const handleClosePopup = () => {
    setShowModal(false);
  }

  const handleSetProvince = (province) => {
    setProvince(province);
    setArea(null)
    setCity(null)
  }

  const handleSetCity = (city) => {
    setCity(city);
    setArea(null)
  }

  const handleSetArea = (area) => {
    setArea(area)
  }

  const submitForm = () => {
    dispatch(tryPostNewAddress({
      isDefault: isDefault.value,
      city, province,
      area,
      label: label,
      landmark: landmark.value.trim(),
      alternateNumber: alternateNumber.value.trim(),
      customerId:customerId
    }))
  }

  return (
    <CustomModal
      loading={false}
      showModal={showModal} setShowModal={handleClosePopup}
      bodyClasses='max-w-[600px]'
      title="Add Address"
      buttonLabel="Add Address"
      disabled={!isAllFieldValid() || isNotAvailableForCampaign ||false }
      onClick={submitForm}>
      <div className="">

        <ProvinceSelector province={province} disabled={false} setProvince={handleSetProvince} className="mb-3"
                          editPopup={editPopup} error={isCampaign && province && !province?.campaign_location ? "This campaign is not available in this province." : ""}/>

        <LocationSelector parent={province} location={city} isCity={true} disabled={false}
                          setLocation={handleSetCity} className="mb-3"
                          isParentEmpty={province === null}
                          error={isCampaign && city && !city?.campaign_location ? "This campaign is not available in this city." : ""}
        />
        <LocationSelector parent={city} location={area} isCity={false} disabled={false}
                          setLocation={handleSetArea} className="mb-3"
                          isParentEmpty={city === null}
                          error={isCampaign && area && !area?.campaign_location ? "This campaign is not available in this area." : ""}
        />
        <Input
          value={label}
          name='label'
          disabled={true}
          placeholder='Address Label *'
        />

        <Input
          disabled={false}
          value={landmark.value}
          name='landmark'
          onChange={landmark.onChange}
          placeholder='Landmark *'
        />

        <Input
          value={alternateNumber.value}
          name='phone'
          disabled={false}
          onChange={alternateNumber.onChange}
          placeholder='Alternate Number'
        />

        <div className="flex items-center space-x-4">
          <label className="ml-3">Set As Default Address</label>
          <input type="checkbox" checked={isDefault.value} className="h-4 w-4"
                 disabled={false || isDefaultAddress.current}
                 onChange={(e) => !isDefaultAddress.current && isDefault.onChange(e)}/>
        </div>
      </div>
    </CustomModal>
  )
}
